import React from 'react';

export const ProgressBar = ({ progress }) => {
    return (
        <div className="prism-progress">
            <div className="prism-progress-bar">
                <div style={{ width: `${progress}%` }} />
            </div>
            <div>{progress}%</div>
        </div>
    );
};

export default ProgressBar;
